import AppParagraph from './AppParagraph';

export default AppParagraph;
